import { Item } from "./Item";
import { ItemVariation } from "./ItemVariation";

export abstract class NamingTemplates {
	static namingTemplateSuffixes = [
		{
			id: "originalName",
			name: "originalName",
			title: "Original Name",
			defaultValue: "",
		},
		{
			id: "type",
			name: "type",
			title: "Type",
			defaultValue: {
				id: 0,
				name: "vid",
				title: "Vid",
			},
			values: [
				{
					id: 0,
					name: "vid",
					title: "Vid",
				},
				{
					id: 1,
					name: "img",
					title: "Img",
				},
			],
		},
		{
			id: "version",
			name: "version",
			title: "Version",
			defaultValue: {
				id: 0,
				name: `"v" + %index%`,
				title: `v1,v2,... by Item`,
			},
			values: [
				{
					id: 0,
					name: `"v" + %index%`,
					title: `v1,v2,... by Item`,
				},
				{
					id: 1,
					name: `"ver" + %index%`,
					title: `ver1,ver2,... by Item`,
				},
				{
					id: 2,
					name: `"v" + %index%`,
					title: `v1,v2,... by Output`,
				},
				{
					id: 3,
					name: `"ver" + %index%`,
					title: `ver1,ver2,... by Output`,
				},
				{
					id: 4,
					name: `"v" + %index%`,
					title: `v(custom) by Item`,
					customStartIndex: 1
				},
				{
					id: 5,
					name: `"v" + %index%`,
					title: `v(custom) by Output`,
					customStartIndex: 1
				},
			],
		},
		{
			id: "id",
			name: "id",
			title: "ID",
			defaultValue: {
				id: 0,
				name: `%index%`,
				title: `1,2,...`,
			},
			values: [
				{
					id: 0,
					name: `%index%`,
					title: `1,2,...`,
				},
			],
		},
		{
			id: "size",
			name: "size",
			title: "Size",
			defaultValue: {
				id: 0,
				name: `%width_px% + "x" + %height_px%`,
				title: `Width x height`,
			},
			values: [
				{
					id: 2,
					name: `%f/s/h/p/v%`,
					title: `Symbol`,
				},
				{
					id: 1,
					name: `%aspect_ratio% + "x"`,
					title: `Aspect ratio`,
				},
				{
					id: 0,
					name: `%width_px% + "x" + %height_px%`,
					title: `Width x height`,
				},

			]
		},
		{
			id: "duration",
			name: "duration",
			title: "Duration",
			defaultValue: {
				id: 1,
				name: `%duration% + "s"`,
				title: `Duration + s`,
			},
			values: [
				{
					id: 0,
					name: `%duration%`,
					title: `Duration`,
				},
				{
					id: 1,
					name: `%duration% + "s"`,
					title: `Duration + s`,
				},
				{
					id: 2,
					name: `%duration% + "sec"`,
					title: `Duration + sec`,
				},],
		},
		{
			id: "language",
			name: "language",
			title: "Language",
			defaultValue: { id: "WW", name: "WW", title: "WW", fullName: "World wide" },
			values: [
				{ id: "WW", name: "WW", title: "WW", fullName: "World wide" },
				{ id: "EN", name: "EN", title: "EN", fullName: "English (All)" },
				{ id: "ES", name: "ES", title: "ES", fullName: "Spanish" },
				{ id: "FR", name: "FR", title: "FR", fullName: "French (All)" },
				{ id: "ZH", name: "ZH", title: "ZH", fullName: "Chinese (All)" },
				{ id: "PT", name: "PT", title: "PT", fullName: "Portuguese (All)" },
				{ id: "EN_US", name: "EN_US", title: "EN_US", fullName: "English (US)" },
				{ id: "CZ", name: "CZ", title: "CZ", fullName: "Czech" },
				{ id: "DK", name: "DK", title: "DK", fullName: "Danish" },
				{ id: "DE", name: "DE", title: "DE", fullName: "German" },
				{ id: "ES_SP", name: "ES_SP", title: "ES_SP", fullName: "Spanish (Spain)" },
				{ id: "FI", name: "FI", title: "FI", fullName: "Finnish" },
				{ id: "FR_FR", name: "FR_FR", title: "FR_FR", fullName: "French (France)" },
				{ id: "HU", name: "HU", title: "HU", fullName: "Hungarian" },
				{ id: "IT", name: "IT", title: "IT", fullName: "Italian" },
				{ id: "JP", name: "JP", title: "JP", fullName: "Japanese" },
				{ id: "KR", name: "KR", title: "KR", fullName: "Korean" },
				{ id: "NO_BK", name: "NO_BK", title: "NO_BK", fullName: "Norwegian (bokmal)" },
				{ id: "NO_NN", name: "NO_NN", title: "NO_NN", fullName: "Norwegian (nynorsk)" },
				{ id: "NL", name: "NL", title: "NL", fullName: "Dutch" },
				{ id: "PL", name: "PL", title: "PL", fullName: "Polish" },
				{ id: "PT_BR", name: "PT_BR", title: "PT_BR", fullName: "Portuguese (Brazil)" },
				{ id: "PT_PT", name: "PT_PT", title: "PT_PT", fullName: "Portuguese (Portugal)" },
				{ id: "RO", name: "RO", title: "RO", fullName: "Romanian" },
				{ id: "RU", name: "RU", title: "RU", fullName: "Russian" },
				{ id: "SK", name: "SK", title: "SK", fullName: "Slovak" },
				{ id: "SI", name: "SI", title: "SI", fullName: "Slovenian" },
				{ id: "SE", name: "SE", title: "SE", fullName: "Swedish" },
				{ id: "TH", name: "TH", title: "TH", fullName: "Thai" },
				{ id: "TR", name: "TR", title: "TR", fullName: "Turkish" },
				{ id: "ZH_CN", name: "ZH_CN", title: "ZH_CN", fullName: "Simplified Chinese (China)" },
				{ id: "ZH_HK", name: "ZH_HK", title: "ZH_HK", fullName: "Traditional Chinese (Hong Kong)" },
				{ id: "ZH_TW", name: "ZH_TW", title: "ZH_TW", fullName: "Traditional Chinese (Taiwan)" },
				{ id: "CF", name: "CF", title: "CF", fullName: "Afrikaans" },
				{ id: "AL", name: "AL", title: "AL", fullName: "Albanian" },
				{ id: "AM", name: "AM", title: "AM", fullName: "Armenian" },
				{ id: "AZ", name: "AZ", title: "AZ", fullName: "Azerbaijani" },
				{ id: "BY", name: "BY", title: "BY", fullName: "Belarusian" },
				{ id: "BA", name: "BA", title: "BA", fullName: "Bosnian" },
				{ id: "BG", name: "BG", title: "BG", fullName: "Bulgarian" },
				{ id: "HR", name: "HR", title: "HR", fullName: "Croatian" },
				{ id: "BE", name: "BE", title: "BE", fullName: "Dutch (België)" },
				{ id: "EN_UK", name: "EN_UK", title: "EN_UK", fullName: "English (UK)" },
				{ id: "EE", name: "EE", title: "EE", fullName: "Estonian" },
				{ id: "FO", name: "FO", title: "FO", fullName: "Faroese" },
				{ id: "FR_CA", name: "FR_CA", title: "FR_CA", fullName: "French (Canada)" },
				{ id: "GE", name: "GE", title: "GE", fullName: "Georgian" },
				{ id: "GR", name: "GR", title: "GR", fullName: "Greek" },
				{ id: "IS", name: "IS", title: "IS", fullName: "Icelandic" },
				{ id: "ID", name: "ID", title: "ID", fullName: "Indonesian" },
				{ id: "IE", name: "IE", title: "IE", fullName: "Irish" },
				{ id: "KZ", name: "KZ", title: "KZ", fullName: "Kazakh" },
				{ id: "LV", name: "LV", title: "LV", fullName: "Latvian" },
				{ id: "LT", name: "LT", title: "LT", fullName: "Lithuanian" },
				{ id: "MK", name: "MK", title: "MK", fullName: "Macedonian" },
				{ id: "MY", name: "MY", title: "MY", fullName: "Malay" },
				{ id: "MN", name: "MN", title: "MN", fullName: "Mongolian" },
				{ id: "NP", name: "NP", title: "NP", fullName: "Nepali" },
				{ id: "RS", name: "RS", title: "RS", fullName: "Serbian" },
				{ id: "UZ", name: "UZ", title: "UZ", fullName: "Uzbek" },
				{ id: "VN", name: "VN", title: "VN", fullName: "Vietnamese" },
				{ id: "TJ", name: "TJ", title: "TJ", fullName: "Tajik" },
				{ id: "AR_AE", name: "AR_AE", title: "AR_AE", fullName: "Arabic" },
				{ id: "JP_KN", name: "JP_KN", title: "JP_KN", fullName: "Japanese (Kansai)" },
				{ id: "HI", name: "HI", title: "HI", fullName: "Hindi" }],
		},
		{
			id: "filter",
			name: "filter",
			title: "Filter",
			defaultValue: {
				id: 0,
				name: `%filter%`,
				title: `Filter`,
			},
			values: [
				{
					id: 0,
					name: `%filter%`,
					title: `Filter`,
				},],
		},
		{
			id: null,
			name: "custom",
			title: "Custom",
			defaultValue: "",
		},
	];

	static getNewSuffixByName(suffixName) {
		let suffix = NamingTemplates.namingTemplateSuffixes.find(
			(s) => s.name === suffixName
		);
		return {
			id: suffix.name === "custom" ? `s${(~~(Math.random() * 1e8)).toString(16)}` : suffix.id,
			name: suffix.name,
			title: suffix.title,
			value: suffix.defaultValue
		};
	}

	private static getInHouseChangedParentItemName(variation: ItemVariation): string {
		let initialName = variation.parentItem.name;
		return initialName.replace(/_[sfhvp]_/gmi, "_" + variation.currentSize.name.toLowerCase() + "_");
	}

	static getVariationOutputFileName(variation: ItemVariation, versionItemIndex: number, versionOutputIndex: number, isInHouse: boolean) {
		if (variation.isSaveOriginalName) {
			if (isInHouse) {
				return this.getInHouseChangedParentItemName(variation);
			} else {
				return variation.parentItem.name;
			}
		}
		let fullName = "";
		variation.outputNameTemplate.forEach(suffixObject => {
			let currentSuffix = "";
			switch (suffixObject.name) {
				case "originalName":
					currentSuffix = this.getOriginalNameSuffix(variation, suffixObject);
					break;
				case "type":
					currentSuffix = this.getTypeSuffix(variation, suffixObject);
					break;
				case "version":
					currentSuffix = this.getVersionSuffix(variation, suffixObject, versionItemIndex, versionOutputIndex);
					break;
				case "id":
					currentSuffix = this.getIdSuffix(variation, suffixObject, versionItemIndex);
					break;
				case "size":
					currentSuffix = this.getSizeSuffix(variation, suffixObject);
					break;
				case "duration":
					currentSuffix = this.getDurationSuffix(variation, suffixObject);
					break;
				case "language":
					currentSuffix = this.getLanguageSuffix(variation, suffixObject);
					break;
				case "filter":
					currentSuffix = this.getFilterSuffix(variation, suffixObject);
					break;
				case "custom":
					currentSuffix = this.getCustomSuffix(variation, suffixObject);
					break;

				default:
					break;
			}
			if (currentSuffix !== "") {
				fullName += (fullName !== "" ? "_" : "") + currentSuffix;
			}
		});
		return fullName === "" ? variation.parentItem.name : fullName;
	}

	static getVariationLanguage(variation: ItemVariation) {
		if (variation.isSaveOriginalName) {
			return "";
		}
		let languageSuffix = variation.outputNameTemplate.find(suffixObject => suffixObject.name === "language");
		return languageSuffix ? languageSuffix.value.name.toUpperCase() : "";
	}

	private static getOriginalNameSuffix(variation: ItemVariation, suffixObject: any) {
		return variation.parentItem.name;
	}

	private static getTypeSuffix(variation: ItemVariation, suffixObject: any) {
		return suffixObject.value.name;
	}

	private static getVersionSuffix(variation: ItemVariation, suffixObject: any, versionItemIndex: number, versionOutputIndex: number) {
		switch (suffixObject.value.id) {
			case 0:
				return "v" + versionItemIndex;
			case 1:
				return "ver" + versionItemIndex;
			case 2:
				return "v" + versionOutputIndex;
			case 3:
				return "ver" + versionOutputIndex;
			case 4:
				return "v" + (suffixObject.value.customStartIndex + versionItemIndex - 1);
			case 5:
				return "v" + (suffixObject.value.customStartIndex + versionOutputIndex - 1);
			default:
				break;
		}
		return "";
	}

	static getIdSuffix(variation: ItemVariation, suffixObject: any, versionIndex: number): string {
		switch (suffixObject.value.id) {
			case 0:
				return versionIndex.toString();
			default:
				break;
		}
		return "";
	}

	private static getSizeSuffix(variation: ItemVariation, suffixObject: any) {
		switch (suffixObject.value.id) {
			case 0:
				let pixelScale =
					Math.round(
						variation.previewParameters.outerVideoResolutionX *
						(variation.parentItem.isOutsize &&
							variation.currentSize.title === "Original"
							? 1
							: variation.previewParameters
								.userOuterVideoResolutionsDifference)
					) +
					"x" +
					Math.round(
						variation.previewParameters.outerVideoResolutionY *
						(variation.parentItem.isOutsize &&
							variation.currentSize.title === "Original"
							? 1
							: variation.previewParameters
								.userOuterVideoResolutionsDifference)
					);
				return pixelScale;
			case 1:
				return Item.getVideoSize(variation.currentSize.name).simpleTitle.replace(":", "x");
			case 2:
				return variation.currentSize.name.toLowerCase();
			default:
				break;
		}
		return "";
	}

	private static getDurationSuffix(variation: ItemVariation, suffixObject: any) {
		let mainDuration = (variation.cut.finishTime -
			variation.cut.startTime) /
			variation.speed;

		let endCardDuration = variation.endCard.getDuration(variation.currentSize.name.toLowerCase());
		
		let duration = Math.floor(mainDuration + endCardDuration).toString();
		switch (suffixObject.value.id) {
			case 0:
				return duration;
			case 1:
				return duration + "s";
			case 2:
				return duration + "sec";
			default:
				break;
		}
		return "";
	}

	private static getLanguageSuffix(variation: ItemVariation, suffixObject: any) {
		return suffixObject.value.name.toLowerCase();
	}

	private static getFilterSuffix(variation: ItemVariation, suffixObject: any) {
		let filterSuffix = '';
		switch (variation.filter.currentPreset) {
			case "Black & White":
				filterSuffix = "b_w";
				break;
			case "Brightness":
				filterSuffix = "brightness";
				break;
			case "Saturation":
				filterSuffix = "saturation";
				break;
			case "Invert":
				filterSuffix = "invert";
				break;
			case "Contrast":
				filterSuffix = "contrast";
				break;
			case "Sepia":
				filterSuffix = "sepia";
				break;
			case "Glitch":
				filterSuffix = "glitch";
				break;
			default:
				break;
		}
		return filterSuffix;
	}

	private static getCustomSuffix(variation: ItemVariation, suffixObject: any) {
		return suffixObject.value;
	}
}
